import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Use generated JSON locale files as the source of truth
import enJson from './locales/en.json';
import koJson from './locales/ko.json';
import zhCNJson from './locales/zhCN.json';
import zhTWJson from './locales/zhTW.json';
import jpJson from './locales/jp.json';
// Optional: helper to dynamically load split namespaces on demand
// Consumers can call ensureNamespaces(["trading", ...]) before using a ns
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - JS file importing TS helper is fine in build
import { ensureNamespaces } from './loadNamespace';

i18n
  .use(LanguageDetector) // 브라우저 언어 감지기 사용
  .init({
    debug: true,
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false
    },
    resources: {
      // Keep existing monolithic JSONs under the "common" namespace
      ko: { common: koJson },
      en: { common: enJson },
      'zh-TW': { common: zhTWJson },
      'zh-HK': { common: zhTWJson },
      'zh-CN': { common: zhCNJson },
      jp: { common: jpJson }
    },
    detection: {
      order: [
        'customDetector',
        'querystring',
        'localStorage',
        'cookie',
        'navigator',
        'htmlTag',
        'path',
        'subdomain'
      ],
      caches: ['localStorage', 'cookie']
    }
  });

// Small convenience to preload extra namespaces when needed
export async function preloadNamespaces(namespaces) {
  await ensureNamespaces(namespaces);
}

export default i18n;
